import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  Bot, 
  Download, 
  Bell, 
  FileText,
  AlertTriangle,
  CheckCircle2,
  Info,
  Database,
  ChevronDown,
  ChevronRight
} from 'lucide-react';

const iconMap = {
  download: Download,
  bell: Bell,
  'file-text': FileText,
  database: Database,
};

export const QuerySummary = ({ summary, metadata }) => {
  const { title, content, actions } = summary;
  const [isExpanded, setIsExpanded] = useState(true);

  // Parse markdown-like content
  const renderContent = (text) => {
    return text.split('\n').map((line, idx) => {
      let processedLine = line.replace(/\*\*(.*?)\*\*/g, '<strong class="text-gray-200">$1</strong>');
      processedLine = processedLine.replace(/`(.*?)`/g, '<code class="px-1 py-0.5 rounded bg-slate-800 text-blue-400 font-mono text-[10px]">$1</code>');
      
      if (line.startsWith('**') && line.endsWith(':')) {
        return <h4 key={idx} className="font-medium text-gray-200 mt-3 mb-1.5 first:mt-0 text-xs" dangerouslySetInnerHTML={{ __html: processedLine }} />;
      }
      if (line.startsWith('- ')) {
        return <li key={idx} className="text-xs text-gray-400 ml-3 mb-0.5" dangerouslySetInnerHTML={{ __html: processedLine.slice(2) }} />;
      }
      if (line.trim() === '') return <br key={idx} />;
      return <p key={idx} className="text-xs text-gray-400 mb-1.5" dangerouslySetInnerHTML={{ __html: processedLine }} />;
    });
  };

  return (
    <div className="mb-3" data-testid="query-summary">
      <div className="rounded-xl bg-slate-950/50 overflow-hidden">
        {/* Header - Clickable */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full text-left p-4 flex items-center justify-between hover:bg-slate-900/30 transition-colors"
        >
          <div className="flex items-center gap-2.5">
            <span className="text-gray-500">
              {isExpanded ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
            </span>
            <h3 className="text-sm font-medium text-gray-200">{title}</h3>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-emerald-400 bg-emerald-500/10 px-2 py-0.5 rounded-full">
            <CheckCircle2 className="w-3.5 h-3.5" />
            Complete
          </span>
        </button>

        {/* Content */}
        {isExpanded && (
          <div className="px-4 pb-4">
            {/* Content */}
            <div className="prose prose-sm prose-invert max-w-none">
              {renderContent(content)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuerySummary;
